import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row justify-content-center h-100" };
const _hoisted_2 = {
    class: "col-12 d-flex flex-column h-100",
    id: "block_error"
};
const _hoisted_3 = { class: "flex-grow-1" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h2", null, "Opps! Es ist ein Fehler aufgetreten...", -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_6 = { class: "row mt-3" };
const _hoisted_7 = {
    class: "col-12",
    style: { "white-space": "pre-line" }
};
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_9 = { class: "text-warning" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("td", { style: { "padding-right": "50px" } }, "Zeitstempel:", -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("td", null, "Fehler:", -1);
const _hoisted_12 = { class: "row mt-3" };
const _hoisted_13 = { class: "col-12" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_button = _resolveComponent("g-button");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.errorMessage?.error_message ?? _ctx.errorMessage?.message), 1)
                ])
            ]),
            _createElementVNode("div", null, [
                _hoisted_8,
                _createElementVNode("table", _hoisted_9, [
                    _createElementVNode("tr", null, [
                        _hoisted_10,
                        _createElementVNode("td", null, _toDisplayString(_ctx.$utils.formatDate(Date.now(), 'date-time')), 1)
                    ]),
                    _createElementVNode("tr", null, [
                        _hoisted_11,
                        _createElementVNode("td", null, _toDisplayString(_ctx.$utils.createId()), 1)
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_g_button, {
                        text: _ctx.$tc('shared.Text.Back'),
                        onClick: _withModifiers(_ctx.onBack, ["stop", "prevent"])
                    }, null, 8, ["text", "onClick"])
                ])
            ])
        ])
    ]));
}
